{
  "name": "glovostore",
  "version": "1.0.408",
  "scripts": {
    "start": "ng serve --host 0.0.0.0",
    "serve:staging": "ng build --configuration=gv-staging && npm run sentry:sourcemaps-staging && npx serve ./dist/glovostore/browser -l 4200 -s",
    "generate:svg": "svg-generator",
    "prebuild": "npm run generate:svg",
    "prebuild:gv-production": "npm run generate:svg",
    "prebuild:gv-staging": "npm run generate:svg",
    "build:gv-production": "ng build --configuration=gv-production && npm run sentry:sourcemaps-prod",
    "build:gv-staging": "ng build --configuration=gv-staging && npm run sentry:sourcemaps-staging",
    "prebuild:gv-ssr": "npm run generate:svg && npm --no-git-tag-version version patch",
    "build:gv-ssr": "ng build --configuration=gv-ssr && node scripts/purge-css.mjs",
    "test": "ng test",
    "lint": "ng lint",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org glovo-dx --project $SENTRY_PROJECT ./dist/glovostore/browser && sentry-cli sourcemaps upload --org glovo-dx --project $SENTRY_PROJECT ./dist/glovostore/browser",
    "sentry:sourcemaps-staging": "SENTRY_PROJECT=frontend-staging npm run sentry:sourcemaps",
    "sentry:sourcemaps-prod": "SENTRY_PROJECT=frontend-prod npm run sentry:sourcemaps",
    "check-budgets": "node scripts/check-budgets.mjs",
    "lighthouse:mobile": "lhci autorun --config=.lighthouserc.mobile.js",
    "lighthouse:desktop": "lhci autorun --config=.lighthouserc.desktop.js"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.19",
    "@angular/common": "^19.2.19",
    "@angular/compiler": "^19.2.19",
    "@angular/core": "^19.2.19",
    "@angular/forms": "^19.2.19",
    "@angular/localize": "^19.2.19",
    "@angular/platform-browser": "^19.2.19",
    "@angular/platform-browser-dynamic": "^19.2.19",
    "@angular/platform-server": "^19.2.19",
    "@angular/router": "^19.2.19",
    "@angular/ssr": "^19.2.19",
    "@ng-bootstrap/ng-bootstrap": "^18.0.0",
    "@ng-select/ng-select": "^14.0.0",
    "@ngneat/svg-icon": "^8.0.0",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^7.0.0",
    "@popperjs/core": "^2.11.8",
    "@sentry/angular": "^8.55.0",
    "bootstrap": "^5.3.3",
    "embla-carousel": "^7.1.0",
    "embla-carousel-autoplay": "^7.1.0",
    "express": "^4.22.1",
    "file-saver-es": "^2.0.5",
    "lodash-es": "^4.17.22",
    "ng-magnizoom": "^1.2.0",
    "ngx-infinite-scroll": "^19.0.0",
    "ngx-mask": "^16.4.2",
    "ngx-ui-loader": "^13.0.0",
    "posthog-js": "^1.353.0",
    "rxjs": "^7.8.1",
    "ts-md5": "^1.3.1",
    "tslib": "^2.3.0",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.19",
    "@angular/cli": "19.2.18",
    "@angular/compiler-cli": "19.2.18",
    "@lhci/cli": "^0.15.1",
    "@ngneat/svg-generator": "^7.0.3",
    "@sentry/cli": "^2.58.5",
    "@types/express": "^4.17.25",
    "@types/file-saver": "^2.0.3",
    "@types/google.maps": "^3.54.6",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^16.11.7",
    "ajv": "^8.12.0",
    "ajv-keywords": "^5.1.0",
    "angular-eslint": "20.1.1",
    "compression-webpack-plugin": "^10.0.0",
    "critical": "^7.2.1",
    "eslint": "^9.29.0",
    "http-proxy-middleware": "^3.0.5",
    "purgecss": "^8.0.0",
    "svgo": "^4.0.1",
    "ts-node": "^8.3.0",
    "typescript": "^5.2.0",
    "typescript-eslint": "^8.34.1"
  },
  "svgGenerator": {
    "srcPath": "src/assets/img",
    "outputPath": "src/app/generated/svg",
    "svgoConfig": {
      "plugins": [
        "preset-default",
        "removeDimensions"
      ]
    },
    "rootBarrelFile": false
  }
}
